module.exports = __webpack_public_path__ + "static/media/dubai-mall.3da4fa73.jpeg";